@import 'fluid-rating.theme.less';

@import '../../styles/mixins/fluid-form-elements.mixin.less';
@import '../../styles/mixins/fluid-transitions.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-rating {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @rating-tokens: @rating-tokens-legacy;
      @rating();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @rating-tokens: @rating-tokens-lm;
      @rating();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @rating-tokens: @rating-tokens-corp;
      @rating();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @rating-tokens: @rating-tokens-portal;
      @rating();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@rating: {
  font-family: @font-family;
  font-size: @font-size;
  line-height: @line-height;
  color: @color-text;

  .form-group {
    .fluid-form-group();
  }

  .input-wrapper {
    .fluid-input(@rating-tokens);

    padding: @rating-tokens[padding];
    box-shadow: @rating-tokens[box-shadow];

    .cancel {
      position: absolute;
      right: 0.8em;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  // ==== Buttons Container

  .rating-container {
    display: inline-flex;
    min-height: @form-field-height;

    &:not(.input-wrapper) {
      & ~ .form-element-notifications {
        padding-top: 0;
      }
    }
  }

  // ==== Rating Button

  .rating-icon-container {
    @button-reset();
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    line-height: 1;
    padding-left: 0.125em;
    padding-right: 0.125em;
    outline: none;
    cursor: pointer;

    // == Hover / Focus Visible States

    &:not(.star-disabled) {
      &:hover,
      &:focus-visible {
        svg {
          transform: scale(1.25);
        }
      }
    }

    // == Disabled State

    &.star-disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    // == SVG Sizes

    .create-svg-sizes();

    // == SVG Fill Colors

    &.icon-state {
      &-empty {
        .star-outline {
          fill: @liberty-gray-69;
        }
      }

      &-partial,
      &-fill {
        .star-outline {
          fill: @liberty-blue;
        }
        .star-fill {
          fill: @liberty-yellow;
        }
      }
    }

    // == SVG Transform Transitions

    svg {
      transition: transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
      transform-origin: 50% 50%;
    }
  }
}

// ================================================================ //
// -- Utility Detached Ruleset(s)

@button-reset: {
  background-color: transparent;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
  border: 0;
  color: inherit;
  cursor: pointer;
};

// ================================================================ //
// -- Mixins

.create-svg-sizes() {
  @svg-sizes: {
    sm: 1em;
    md: 1.5em;
    lg: 2em;
    xl: 2.5em;
  }

  each(@svg-sizes, {
    &.icon-size-@{key} {
      svg {
        width: @value;
        height: @value;
      }
    }
  });
}
